module.exports = __webpack_public_path__ + "img/bg_5.476576d8.png";